// extracted by mini-css-extract-plugin
export var logo = "_9s-2";
export var logoWrapper = "_9s-1";
export var strip = "_9s-0";